import script from "./T3dHelpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./T3dHelpModal.vue?vue&type=script&setup=true&lang=js"

import "./T3dHelpModal.vue?vue&type=style&index=0&id=afaf4e08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afaf4e08"]])

export default __exports__